import { useLayoutEffect } from "react";

export const TvRedirect = () => {
  useLayoutEffect(() => {
    try {
      const kcConfig = JSON.parse(import.meta.env.VITE_KC_AUTH_CONFIG || "{}");
      const { serverUrl, realm } = kcConfig;

      if (serverUrl && realm) {
        const baseUrl = serverUrl.endsWith("/") ? serverUrl : `${serverUrl}/`;
        window.location.href = `${baseUrl}realms/${realm}/device`;
        return;
      }
    } catch {
      // KC config parse failed - ignore
    }
  }, []);

  return null;
};
